var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnTheatre(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 11.373 13",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fffffe",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.305 4.9H3.861a.893.893 0 00-.89.891v1.222l-.957-.552-1.241-.717C.347 5.499 0 5.699 0 6.189v4.648c0 .49.347.69.773.445l1.241-.716.957-.553v1.222a.893.893 0 00.89.891h.558v.33a.544.544 0 001.089 0v-.329h2.149v.33a.544.544 0 001.089 0v-.33h.559a.893.893 0 00.89-.891V5.791a.893.893 0 00-.89-.891M4.669 4.641a2.321 2.321 0 10-2.321-2.32 2.32 2.32 0 002.321 2.32m0-1.952a.368.368 0 11.367-.368.368.368 0 01-.367.368m1.455-1.316a.46.46 0 11-.459.459.46.46 0 01.459-.459m-.459 1.589a.46.46 0 11-.46.46.46.46 0 01.46-.46M4.619.454a.46.46 0 11-.459.459.459.459 0 01.459-.459m-.487 2.968a.459.459 0 11-.459-.46.459.459 0 01.459.46m-1.379-1.59a.46.46 0 11.46.46.46.46 0 01-.46-.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31.519a2.062 2.062 0 102.063 2.06A2.062 2.062 0 009.31.519m-1.7 1.629a.409.409 0 11.408.408.408.408 0 01-.408-.408m.817 1.821a.409.409 0 11.409-.409.409.409 0 01-.409.409m.885-1.061a.327.327 0 11.327-.327.327.327 0 01-.327.327m-.047-1.169a.409.409 0 11.408-.41.409.409 0 01-.408.41m.933 2.23a.409.409 0 11.408-.409.408.408 0 01-.408.409m.408-1.413a.408.408 0 11.408-.408.408.408 0 01-.408.408"
  }))));
}

export default SvgIcnTheatre;